import { Reveal } from "@/components/Reveal";

const chapters = [
  {
    no: "01",
    title: "Awareness before advice",
    body: "You can't fix what you can't see. We start by understanding how you actually spend, save and feel about money — no jargon, no judgment.",
  },
  {
    no: "02",
    title: "Simple beats sophisticated",
    body: "The best financial plan is the one you'll actually follow. We build habits that are practical enough to survive real life.",
  },
  {
    no: "03",
    title: "Unbiased, always",
    body: "No products to push, no commissions. Just honest guidance built around your goals, your income and your peace of mind.",
  },
  {
    no: "04",
    title: "Knowledge that compounds",
    body: "Learn the principles once and they pay off for decades. Financial literacy is the highest-return investment you'll ever make.",
  },
];

const ManifestoSection = () => (
  <section
    data-testid="manifesto-section"
    className="grain relative overflow-hidden bg-primary px-6 py-24 md:px-12 md:py-32"
  >
    <div className="relative z-10 mx-auto max-w-[1400px]">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-secondary md:text-sm">
          The Approach
        </p>
        <h2 className="mt-6 max-w-3xl font-display text-4xl font-medium leading-tight tracking-tight text-primary-foreground md:text-6xl">
          Four principles that guide every conversation.
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-sm border border-primary-foreground/10 bg-primary-foreground/10 md:grid-cols-2">
        {chapters.map((c, i) => (
          <Reveal
            key={c.no}
            delay={i * 0.08}
            className="group bg-primary p-10 transition-colors duration-500 hover:bg-[#0A2E23] md:p-14"
          >
            <div className="flex items-start gap-6">
              <span className="font-display text-5xl font-medium italic text-secondary/50 transition-colors duration-500 group-hover:text-secondary md:text-6xl">
                {c.no}
              </span>
              <div>
                <h3 className="font-display text-2xl font-medium text-primary-foreground md:text-3xl">
                  {c.title}
                </h3>
                <p className="mt-4 text-base font-light leading-relaxed text-primary-foreground/65 md:text-lg">
                  {c.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ManifestoSection;
